const codeSnippetEntityComponentSelector = 
`props.ComponentSelector("Anim Controller", mAnimControllerHandle);`;

export { codeSnippetEntityComponentSelector };